import PolicyEditor from "./PolicyEditor";

export default function PrivacyAdmin() {
  return <PolicyEditor kind="privacy" />;
}
